import { Inject, Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { PLATFORM_STARTUP_ERROR_HANDLERS } from '@platform-frontend/platform';
import { HandleErrorsGlobalRecord } from '@platform-frontend/util';
import { Observable, of, switchMap } from 'rxjs';
import { AccountRouteService } from '../account-router';
import { AuthenticationServiceToken, IAuthenticationService } from '../account-services';
import { AccountStartupContext } from '../model';
import { StartupService } from '../startup.service';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class AccountStartupService {
  constructor(
    private accountRouteService: AccountRouteService,
    @Inject(AuthenticationServiceToken) private authenticationService: IAuthenticationService,
    private startupService: StartupService
  ) {}

  getStartupObservable(
    paramMap: ParamMap,
    context: AccountStartupContext,
    getStartupActions: () => Observable<unknown> = () => of(null),
    startupErrorHandlers: (error: any) => HandleErrorsGlobalRecord = PLATFORM_STARTUP_ERROR_HANDLERS
  ): Observable<unknown> {
    return this.authenticationService
      .getStartupObservable(this.accountRouteService.getStartParams(paramMap), context)
      .pipe(switchMap(() => this.startupService.getStartupObservable(() => getStartupActions(), startupErrorHandlers)));
  }
}
